import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOnMount } from '~/hooks/useOnMount';
import { useIntercomStarter } from './IntercomStarter';
export function withEnableIntercom(Component, enableIntercom) {
    return function WithEnableIntercom(props) {
        const { setEnableIntercom } = useIntercomStarter();
        useOnMount(()=>{
            setEnableIntercom(enableIntercom);
        });
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
}
